import { removeToken, setIsAuthenticated, setIsInitializing, } from '@innovyze/stylovyze/lib/actions/authenticationContext.actions';
import { getAuthenticationToken } from '@innovyze/stylovyze/lib/services/forge.service';
import { useDispatch } from 'react-redux';
import useDispatchForgeLogout from './useDispatchForgeLogout';
export const useRetrieveToken = (options, config) => {
    const { redirectUri } = options;
    const dispatch = useDispatch();
    const dispatchForgeLogout = useDispatchForgeLogout();
    const retrieveToken = async () => {
        const query = new URLSearchParams(window.location.search);
        const code = query.get('code');
        const codeVerifier = localStorage.getItem('codeVerifier');
        const forgeTokenResponse = await getAuthenticationToken(config?.forge, redirectUri, code, codeVerifier, dispatchForgeLogout);
        if (!forgeTokenResponse?.data) {
            console.warn('LOGIN_V2: !forgeTokenResponse?.data', forgeTokenResponse);
            dispatch(removeToken());
            dispatch(setIsAuthenticated(false));
            dispatch(setIsInitializing(true));
            dispatchForgeLogout();
            return;
        }
        const idToken = forgeTokenResponse?.data?.id_token;
        const accessToken = forgeTokenResponse?.data?.access_token;
        const refreshToken = forgeTokenResponse?.data?.refresh_token;
        const expiresInSeconds = forgeTokenResponse?.data?.expires_in;
        return {
            idToken,
            accessToken,
            refreshToken,
            expiresInSeconds,
        };
    };
    return { retrieveToken };
};
export default useRetrieveToken;
